import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

/**
 * ListLoadingSkeleton — Loading state placeholder for list endpoints.
 * Shows shimmer effect while data is being fetched.
 *
 * @param {number} count - Number of skeleton items to show (default: 5)
 */
export const ListLoadingSkeleton = ({ count = 5, height = 60 }) => {
  return (
    <Stack spacing={1.5}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rounded"
          height={height}
          sx={{
            animation: 'pulse 1.5s ease-in-out infinite',
            '@keyframes pulse': {
              '0%, 100%': { opacity: 1 },
              '50%': { opacity: 0.5 },
            },
          }}
        />
      ))}
    </Stack>
  );
};

/**
 * TableHeaderSkeleton — Loading state for table headers
 */
export const TableHeaderSkeleton = ({ columnCount = 5 }) => {
  return (
    <Stack direction="row" spacing={1}>
      {Array.from({ length: columnCount }).map((_, i) => (
        <Skeleton key={i} variant="text" width={100} height={20} />
      ))}
    </Stack>
  );
};

/**
 * CardSkeleton — Loading state for card layouts
 */
export const CardSkeleton = ({ count = 4 }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
        gap: 2,
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton
          key={i}
          variant="rounded"
          height={200}
          sx={{
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        />
      ))}
    </Box>
  );
};

/**
 * SkeletonGrid — Generic grid of skeleton items
 */
export const SkeletonGrid = ({ rows = 3, columns = 4 }) => {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: 2 }}>
      {Array.from({ length: rows * columns }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={80} />
      ))}
    </Box>
  );
};
